var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.data.action.date)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('flowTemplate.forms.extendTimeout.summary', { delay: _vm.delay, times: _vm.data.action.iteration }))+" ")]):_c('el-alert',{attrs:{"type":"warning","closable":false}},[_vm._v(_vm._s(_vm.$t('flowTemplate.config.missing')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }